export default __webpack_public_path__ + "static/media/MapaUSAstates.de9ef6c6.png";